module.exports = __webpack_public_path__ + "img/lucretia-mott.4aa66cc9.png";